import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export const Lightbox = ({ src, onClose }) => (
  <Dialog open={!!src} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-[95vw] w-auto p-2 bg-white border-0" data-testid="lightbox">
      <DialogTitle className="sr-only">Image preview</DialogTitle>
      {src && <img src={src} alt="Enlarged" className="max-h-[85vh] max-w-[90vw] w-auto h-auto object-contain mx-auto" data-testid="lightbox-image" />}
    </DialogContent>
  </Dialog>
);
